import CountryPageTemplate from "../../components/country/CountryPageTemplate";
import { countryPages } from "../../data/countries";

function GermanyPage() {
  return <CountryPageTemplate country={countryPages.germany} />;
}

export default GermanyPage;
